/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LocaleRouteImport } from './routes/$locale'
import { Route as IndexRouteImport } from './routes/index'
import { Route as CliAuthRouteImport } from './routes/cli/auth'
import { Route as LocalePublicRouteImport } from './routes/$locale/_public'
import { Route as LocaleDashboardRouteImport } from './routes/$locale/_dashboard'
import { Route as LocaleDashboardIndexRouteImport } from './routes/$locale/_dashboard/index'
import { Route as LocalePublicSignUpRouteImport } from './routes/$locale/_public/sign-up'
import { Route as LocalePublicSignInRouteImport } from './routes/$locale/_public/sign-in'
import { Route as LocaleDashboardPricingRouteImport } from './routes/$locale/_dashboard/pricing'
import { Route as LocaleDashboardOnboardingRouteImport } from './routes/$locale/_dashboard/onboarding'
import { Route as LocaleDashboardDocsRouteImport } from './routes/$locale/_dashboard/docs'
import { Route as LocaleDashboardBillingsRouteImport } from './routes/$locale/_dashboard/billings'

const LocaleRoute = LocaleRouteImport.update({
  id: '/$locale',
  path: '/$locale',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const CliAuthRoute = CliAuthRouteImport.update({
  id: '/cli/auth',
  path: '/cli/auth',
  getParentRoute: () => rootRouteImport,
} as any)
const LocalePublicRoute = LocalePublicRouteImport.update({
  id: '/_public',
  getParentRoute: () => LocaleRoute,
} as any)
const LocaleDashboardRoute = LocaleDashboardRouteImport.update({
  id: '/_dashboard',
  getParentRoute: () => LocaleRoute,
} as any)
const LocaleDashboardIndexRoute = LocaleDashboardIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LocaleDashboardRoute,
} as any)
const LocalePublicSignUpRoute = LocalePublicSignUpRouteImport.update({
  id: '/sign-up',
  path: '/sign-up',
  getParentRoute: () => LocalePublicRoute,
} as any)
const LocalePublicSignInRoute = LocalePublicSignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => LocalePublicRoute,
} as any)
const LocaleDashboardPricingRoute = LocaleDashboardPricingRouteImport.update({
  id: '/pricing',
  path: '/pricing',
  getParentRoute: () => LocaleDashboardRoute,
} as any)
const LocaleDashboardOnboardingRoute =
  LocaleDashboardOnboardingRouteImport.update({
    id: '/onboarding',
    path: '/onboarding',
    getParentRoute: () => LocaleDashboardRoute,
  } as any)
const LocaleDashboardDocsRoute = LocaleDashboardDocsRouteImport.update({
  id: '/docs',
  path: '/docs',
  getParentRoute: () => LocaleDashboardRoute,
} as any)
const LocaleDashboardBillingsRoute = LocaleDashboardBillingsRouteImport.update({
  id: '/billings',
  path: '/billings',
  getParentRoute: () => LocaleDashboardRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/$locale': typeof LocalePublicRouteWithChildren
  '/cli/auth': typeof CliAuthRoute
  '/$locale/billings': typeof LocaleDashboardBillingsRoute
  '/$locale/docs': typeof LocaleDashboardDocsRoute
  '/$locale/onboarding': typeof LocaleDashboardOnboardingRoute
  '/$locale/pricing': typeof LocaleDashboardPricingRoute
  '/$locale/sign-in': typeof LocalePublicSignInRoute
  '/$locale/sign-up': typeof LocalePublicSignUpRoute
  '/$locale/': typeof LocaleDashboardIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/$locale': typeof LocaleDashboardIndexRoute
  '/cli/auth': typeof CliAuthRoute
  '/$locale/billings': typeof LocaleDashboardBillingsRoute
  '/$locale/docs': typeof LocaleDashboardDocsRoute
  '/$locale/onboarding': typeof LocaleDashboardOnboardingRoute
  '/$locale/pricing': typeof LocaleDashboardPricingRoute
  '/$locale/sign-in': typeof LocalePublicSignInRoute
  '/$locale/sign-up': typeof LocalePublicSignUpRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/$locale': typeof LocaleRouteWithChildren
  '/$locale/_dashboard': typeof LocaleDashboardRouteWithChildren
  '/$locale/_public': typeof LocalePublicRouteWithChildren
  '/cli/auth': typeof CliAuthRoute
  '/$locale/_dashboard/billings': typeof LocaleDashboardBillingsRoute
  '/$locale/_dashboard/docs': typeof LocaleDashboardDocsRoute
  '/$locale/_dashboard/onboarding': typeof LocaleDashboardOnboardingRoute
  '/$locale/_dashboard/pricing': typeof LocaleDashboardPricingRoute
  '/$locale/_public/sign-in': typeof LocalePublicSignInRoute
  '/$locale/_public/sign-up': typeof LocalePublicSignUpRoute
  '/$locale/_dashboard/': typeof LocaleDashboardIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/$locale'
    | '/cli/auth'
    | '/$locale/billings'
    | '/$locale/docs'
    | '/$locale/onboarding'
    | '/$locale/pricing'
    | '/$locale/sign-in'
    | '/$locale/sign-up'
    | '/$locale/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/$locale'
    | '/cli/auth'
    | '/$locale/billings'
    | '/$locale/docs'
    | '/$locale/onboarding'
    | '/$locale/pricing'
    | '/$locale/sign-in'
    | '/$locale/sign-up'
  id:
    | '__root__'
    | '/'
    | '/$locale'
    | '/$locale/_dashboard'
    | '/$locale/_public'
    | '/cli/auth'
    | '/$locale/_dashboard/billings'
    | '/$locale/_dashboard/docs'
    | '/$locale/_dashboard/onboarding'
    | '/$locale/_dashboard/pricing'
    | '/$locale/_public/sign-in'
    | '/$locale/_public/sign-up'
    | '/$locale/_dashboard/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  LocaleRoute: typeof LocaleRouteWithChildren
  CliAuthRoute: typeof CliAuthRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/$locale': {
      id: '/$locale'
      path: '/$locale'
      fullPath: '/$locale'
      preLoaderRoute: typeof LocaleRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cli/auth': {
      id: '/cli/auth'
      path: '/cli/auth'
      fullPath: '/cli/auth'
      preLoaderRoute: typeof CliAuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$locale/_public': {
      id: '/$locale/_public'
      path: ''
      fullPath: '/$locale'
      preLoaderRoute: typeof LocalePublicRouteImport
      parentRoute: typeof LocaleRoute
    }
    '/$locale/_dashboard': {
      id: '/$locale/_dashboard'
      path: ''
      fullPath: '/$locale'
      preLoaderRoute: typeof LocaleDashboardRouteImport
      parentRoute: typeof LocaleRoute
    }
    '/$locale/_dashboard/': {
      id: '/$locale/_dashboard/'
      path: '/'
      fullPath: '/$locale/'
      preLoaderRoute: typeof LocaleDashboardIndexRouteImport
      parentRoute: typeof LocaleDashboardRoute
    }
    '/$locale/_public/sign-up': {
      id: '/$locale/_public/sign-up'
      path: '/sign-up'
      fullPath: '/$locale/sign-up'
      preLoaderRoute: typeof LocalePublicSignUpRouteImport
      parentRoute: typeof LocalePublicRoute
    }
    '/$locale/_public/sign-in': {
      id: '/$locale/_public/sign-in'
      path: '/sign-in'
      fullPath: '/$locale/sign-in'
      preLoaderRoute: typeof LocalePublicSignInRouteImport
      parentRoute: typeof LocalePublicRoute
    }
    '/$locale/_dashboard/pricing': {
      id: '/$locale/_dashboard/pricing'
      path: '/pricing'
      fullPath: '/$locale/pricing'
      preLoaderRoute: typeof LocaleDashboardPricingRouteImport
      parentRoute: typeof LocaleDashboardRoute
    }
    '/$locale/_dashboard/onboarding': {
      id: '/$locale/_dashboard/onboarding'
      path: '/onboarding'
      fullPath: '/$locale/onboarding'
      preLoaderRoute: typeof LocaleDashboardOnboardingRouteImport
      parentRoute: typeof LocaleDashboardRoute
    }
    '/$locale/_dashboard/docs': {
      id: '/$locale/_dashboard/docs'
      path: '/docs'
      fullPath: '/$locale/docs'
      preLoaderRoute: typeof LocaleDashboardDocsRouteImport
      parentRoute: typeof LocaleDashboardRoute
    }
    '/$locale/_dashboard/billings': {
      id: '/$locale/_dashboard/billings'
      path: '/billings'
      fullPath: '/$locale/billings'
      preLoaderRoute: typeof LocaleDashboardBillingsRouteImport
      parentRoute: typeof LocaleDashboardRoute
    }
  }
}

interface LocaleDashboardRouteChildren {
  LocaleDashboardBillingsRoute: typeof LocaleDashboardBillingsRoute
  LocaleDashboardDocsRoute: typeof LocaleDashboardDocsRoute
  LocaleDashboardOnboardingRoute: typeof LocaleDashboardOnboardingRoute
  LocaleDashboardPricingRoute: typeof LocaleDashboardPricingRoute
  LocaleDashboardIndexRoute: typeof LocaleDashboardIndexRoute
}

const LocaleDashboardRouteChildren: LocaleDashboardRouteChildren = {
  LocaleDashboardBillingsRoute: LocaleDashboardBillingsRoute,
  LocaleDashboardDocsRoute: LocaleDashboardDocsRoute,
  LocaleDashboardOnboardingRoute: LocaleDashboardOnboardingRoute,
  LocaleDashboardPricingRoute: LocaleDashboardPricingRoute,
  LocaleDashboardIndexRoute: LocaleDashboardIndexRoute,
}

const LocaleDashboardRouteWithChildren = LocaleDashboardRoute._addFileChildren(
  LocaleDashboardRouteChildren,
)

interface LocalePublicRouteChildren {
  LocalePublicSignInRoute: typeof LocalePublicSignInRoute
  LocalePublicSignUpRoute: typeof LocalePublicSignUpRoute
}

const LocalePublicRouteChildren: LocalePublicRouteChildren = {
  LocalePublicSignInRoute: LocalePublicSignInRoute,
  LocalePublicSignUpRoute: LocalePublicSignUpRoute,
}

const LocalePublicRouteWithChildren = LocalePublicRoute._addFileChildren(
  LocalePublicRouteChildren,
)

interface LocaleRouteChildren {
  LocaleDashboardRoute: typeof LocaleDashboardRouteWithChildren
  LocalePublicRoute: typeof LocalePublicRouteWithChildren
}

const LocaleRouteChildren: LocaleRouteChildren = {
  LocaleDashboardRoute: LocaleDashboardRouteWithChildren,
  LocalePublicRoute: LocalePublicRouteWithChildren,
}

const LocaleRouteWithChildren =
  LocaleRoute._addFileChildren(LocaleRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  LocaleRoute: LocaleRouteWithChildren,
  CliAuthRoute: CliAuthRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
